import e from "react";
import i from "../../../../../node_modules/classnames/index.js";
import { t as a } from "../../../../i18/index.js";
var t = function t(_t) {
  var r = _t.item,
    m = _t.active,
    n = _t.onClick,
    s = _t.tagActive,
    c = !1;
  return m && s.includes(r) && (c = !0), m || s || r !== a("all") || (c = !0, s = r), e.createElement("div", {
    className: i("sidebar-item", c && "active"),
    onClick: n
  }, e.createElement("span", {
    className: "in-app-videos__sidebar-item"
  }, " ", r, " "));
};
export { t as InAppSidebarItem };